import { store } from '@/store'
import moment from 'moment'

export default {
    data () {
        return {
            patientError: null
        }
    },

    computed: {
        preventBodyScroll () {
            return store.state.preventBodyScroll
        },

        patient () {
            return store.state.patient
        },

        patientPosition () {
            return store.state.patientPosition
        },

        patientPlace () {
            return store.state.patientPlace
        },

        patientPlaceName () {
            return store.state.patientPlaceName
        },

        patientMedicalPractice () {
            return store.state.patientMedicalPractice
        },

        frontLanguage () {
            return store.state.frontLanguage
        },

        patientLanguage () {
            return _.find(this.languages, {shortCode: this.frontLanguage || 'en' })
        },

        patientLanguageName () {
            return this.patientLanguage ? this.patientLanguage.name : 'English'
        },

        currentLayout () {
            return store.state.currentLayout
        },

        online () {
            return store.state.online
        },

        userId () {
            return store.state.userId
        },

        listenAppointments () {
            return store.state.listenAppointments
        },

        isLoading () {
            return store.state.loading
        },

        currentOffice: () => {
            return store.state.currentOffice
        },

        currentDate: () => {
            return store.state.currentDate
        },

        doctor: () => {
            return store.state.doctor
        },

        offices: () => {
            return store.state.offices
        },

        languages: () => {
            return store.state.languages
        },

        countries: () => {
            return store.state.countries
        },

        defaultCountryId: () => {
            return store.state.defaultCountryId
        },

        recommendations: () => {
            return store.state.recommendations
        },

        notifications: () => {
            return _.filter(store.state.notifications, n => n.active)
        },

        showCookieNotification() {
            return ! this.doctor && ! this.consentForCookies
        },

        showRecommendationsModal() {
            return this.doctor && ! this.closedRecommendationsModal && Object.keys(this.recommendations).length < 1 ? true : false
        }
    },

    methods: {
        goBack () {
            this.$router.go(-1)
        },

        timeAgo (date, format) {
            return moment(date, format).fromNow()
        },

        setPreventBodyScroll (preventBodyScroll) {
            store.dispatch('setPreventBodyScroll', preventBodyScroll)
        },

        setLoading (loading) {
            store.dispatch('setLoading', loading)
        },

        setLocale (locale) {
            store.dispatch('setLocale', locale)
        },

        setLoaded (loaded) {
            this.loaded = loaded
        },

        setFormError (error) {
            store.dispatch('setFormError', error)
        },

        setCurrentDate (date) {
            store.dispatch('setCurrentDate', date)
        },

        setCurrentOffice (office) {
            store.dispatch('setCurrentOffice', office)
        },

        setPatientPosition (position) {
            store.dispatch('setPatientPosition', position)
        },

        setPatientPlace (place) {
            store.dispatch('setPatientPlace', place)
        },

        setPatientPlaceName (name) {
            store.dispatch('setPatientPlaceName', name)
        },

        setPatientMedicalPractice (type) {
            store.dispatch('setPatientMedicalPractice', type)
        },

        setListenAppointments (listen) {
            store.dispatch('listenAppointments', listen)
        },

        setUserId (userId) {
            store.dispatch('setUserId', userId)
        },

        setDoctor (doctor) {
            store.dispatch('setDoctor', doctor)
        },

        setOffices (offices) {
            store.dispatch('setOffices', offices)
        },

        setLanguages (languages) {
            store.dispatch('setLanguages', languages)
        },

        addNotification (notification) {
            store.dispatch('addNotification', notification)
        },

        disableNotification (notification) {
            store.dispatch('disableNotification', notification)
        },

        setCountries (countries) {
            store.dispatch('setCountries', countries)

            let country = _.find(countries, {code: 'be'})

            if (country) {
                store.dispatch('setDefaultCountryId', country.id)
            }
        },

        setRecommendations (recommendations) {
            store.dispatch('setRecommendations', recommendations)
        },

        alertPatientError(message, delay = 2500) {
            this.patientError = message

            setTimeout(() => {
                this.patientError = null
            }, delay)
        },

        alertError(message, options = {}) {
            let opts = Object.assign({message: message, type: 'is-danger'}, options)

            this.$toast.open(opts)
        },

        alertWarning(message, options = {}) {
            let opts = Object.assign({message: message, type: 'is-warning'}, options)

            this.$toast.open(opts)
        },

        alertSuccess(message, options = {}) {
            let opts = Object.assign({message: message, type: 'is-success'}, options)

            this.$toast.open(opts)
        },

        hashPatientInfo(value) {
            if (value.length) {
                let hashedValue = []
                let alphabet       = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+@#- )"
                let hashedAlphabet = "ghijklabcdefopmnvwxyzqrstuGHIJKLABCDEFOPMNVWXYZQRSTU3450128967#-+@) "

                for (let i = 0; i < value.length; i++) {
                    let index = alphabet.indexOf(value[i])

                    if (index > -1) {
                        hashedValue.push(hashedAlphabet[index])
                    } else {
                        hashedValue.push(value[i])
                    }
                }

                return hashedValue.join('')
            }
        },

        hasGivenConsentForCookies() {
            if (this.consentForCookies) return true

            let value = '; ' + document.cookie
            let parts = value.split('; cookieconsent_status=')

            return parts.length != 2 ? false : true
        },

        consentCookies() {
            let expirationDate = moment().add(365, 'days')

            let cookie = [
                'cookieconsent_status=1',
                'expires=' + expirationDate.utc().toString(),
                'path=/'
            ]

            document.cookie = cookie.join(';')

            this.consentForCookies = true
        },

        checkIfHasReadCovidNotification() {
            if (this.hasReadCovidNotification) return true

            let value = '; ' + document.cookie
            let parts = value.split('; covid_read=')

            return parts.length != 2 ? false : true
        },

        convertArrayOfObjectsToCSV (args) {
            let result, ctr, keys, attributes, headers, columnDelimiter, lineDelimiter, data;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';

            keys = args.keys;
            attributes = Object.keys(keys)
            headers = Object.keys(keys).map(key => keys[key])

            result = '';
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function(item) {
                ctr = 0;
                attributes.forEach(function(key) {
                    if (ctr > 0) result += columnDelimiter;
                    if (item.hasOwnProperty(key)) {
                        result += item[key] ? item[key] : '';
                    }
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js